module.exports = __webpack_public_path__ + "static/img/diskus_trans.a980f9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trackers/diskus_trans.jpg
// module id = znpL
// module chunks = 0